import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Inject,
  Injector,
  NgModule,
  Type,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MODAL_DATA } from '../tokens/modal-data.token';
import { CommonModule } from '@angular/common';
import { TranslatePipeModule } from '../translate.pipe';

export interface BaseNotificationModalDataOptions {
  showCloseButton?: boolean;
}

export interface BaseNotificationModalData<T> {
  modalComponent: Type<any>;
  data: T & BaseNotificationModalDataOptions;
}

@Component({
  selector: 'lp2-base-notification',
  template: `
    <button
      *ngIf="showCloseButton"
      type="button"
      class="close-button"
      data-test-id="notification-modal-close"
      [attr.aria-label]="'legal.CLOSE' | translate"
      (click)="onClose()"
    >
      <i class="far fa-times" aria-hidden="true"></i>
    </button>
    <ng-container #modalContainer></ng-container>
  `,
  styleUrls: ['./base-notification-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BaseNotificationModalComponent<T> implements AfterViewInit {
  @ViewChild('modalContainer', { read: ViewContainerRef }) container: ViewContainerRef;
  showCloseButton: boolean;

  constructor(
    @Inject(MODAL_DATA) public readonly data: BaseNotificationModalData<T>,
    private readonly ngbActiveModal: NgbActiveModal,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    const componentShowCloseButton = this.projectComponent();
    this.updateShowCloseButton(componentShowCloseButton);
  }

  onClose(): void {
    this.ngbActiveModal.close();
  }

  private updateShowCloseButton(componentShowCloseButton?: boolean) {
    let showCloseButton = true;

    if (componentShowCloseButton !== undefined) {
      showCloseButton = componentShowCloseButton;
    } else if (this.data.data && this.data.data.showCloseButton !== undefined) {
      showCloseButton = this.data.data.showCloseButton;
    } else if (
      ((this.data.data as any) as BaseNotificationModalData<any>).data &&
      ((this.data.data as any) as BaseNotificationModalData<any>).data.showCloseButton !== undefined
    ) {
      showCloseButton = (this.data as BaseNotificationModalData<any>).data.showCloseButton;
    }

    this.showCloseButton = showCloseButton;
    this.changeDetectorRef.detectChanges();
  }

  private projectComponent(): boolean | undefined {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.modalComponent);
    this.container.clear();
    const componentRef = this.container.createComponent(
      componentFactory,
      null,
      Injector.create({
        providers: [
          {
            provide: MODAL_DATA,
            useValue: this.data.data,
          },
          {
            provide: NgbActiveModal,
            useValue: this.ngbActiveModal,
          },
        ],
      })
    );
    componentRef.changeDetectorRef.detectChanges();
    const declared = componentRef.instance.showCloseButton;
    return typeof declared === 'boolean' ? declared : undefined;
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule],
  exports: [BaseNotificationModalComponent],
  declarations: [BaseNotificationModalComponent],
  entryComponents: [BaseNotificationModalComponent],
})
export class BaseNotificationModalModule {}



// WEBPACK FOOTER //
// ./ts/app/shared/base-notification-modal/base-notification-modal.component.ts